import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import AddPositionSelect from "../../components/addPositionSelect/AddPositionSelect";
import SaveBtn from "../../components/saveBtn/SaveBtn";
import ProductsSearchList from "../../components/searchList/ProductsSearchList";
import SearchList from "../../components/searchList/SearchList";
import { useGetPageQuery, useSendFormMutation } from "../../redux/services/crmAPI";
import { useGetPageUnloadQuery } from "../../redux/services/noLoadingReqAPI";

const Order = () => {
    const navigate = useNavigate();
    const permissions = useSelector((state) => state.status.permissions);
    const userPermission = useSelector((state) => state.status.userPermission);

    console.log(userPermission);

    const searchClientRef = useRef();
    const inputClientRef = useRef();
    const searchProductRef = useRef();
    const inputImeitRef = useRef();
    const searchPositionRef = useRef();
    const inputPositionRef = useRef();

    const [showSearchClientList, setShowSearchClientList] = useState(false);
    const [showSearchImeiList, setShowSearchImeiList] = useState(false);
    const [showSearchPositionList, setShowSearchPositionList] = useState(false);

    const [positions, setPositions] = useState([]);

    const [totlaPrice, setTotalPrice] = useState(0);
    const [totlaPriceWithDiscount, setTotalPriceWithDiscount] = useState(0);
    const [productSearchInput, setProductSearchInput] = useState("");

    const [isExchange, setIsExchange] = useState(0);
    const [orderStatusId, setOrderStatusId] = useState(0);
    const [storeId, setStoreId] = useState(9);
    const [isOLX, setIsOLX] = useState(0);
    const [isProm, setIsProm] = useState(0);
    const [isCredit, setIsCredit] = useState(0);
    const [isCard, setIsCard] = useState(0);
    const [isTerminal, setIsTerminal] = useState(0);
    const [discount, setDiscount] = useState(0);
    const [clientId, setClientId] = useState(0);
    const [clientName, setClientName] = useState("");
    const [clientCard, setClientCard] = useState("");
    const [clientPhone, setClientPhone] = useState("");
    const [deliveryTtn, setDeliveryTtn] = useState("");
    const [note, setNote] = useState("");
    const [icloudLogin, setIcloudLogin] = useState("");
    const [icloudPassword, setIcloudPassword] = useState("");
    const [exchangeIsservice, setExchangeIsService] = useState(0);
    const [exchangeTitle, setExchangeTitle] = useState("");
    const [exchangeImeiSn, setExchangeImeiSn] = useState("");
    const [exchangeStatus, setExchangeStatus] = useState("");
    const [exchangePrice, setExchangePrice] = useState(0);
    const [productId, setproductId] = useState(0);
    const [creditBank, setCreditBank] = useState("");
    const [creditContract, setCreditContract] = useState("");
    const [creditAdditional, setCreditAdditional] = useState("");

    const { data: orderStatuses } = useGetPageQuery("order-statuses");
    const [sendForm, { isLoading, isError, error: postFormError, isSuccess, data: sendFormData }] =
        useSendFormMutation();
    const { data: orderPositions } = useGetPageUnloadQuery("orders/positions?limit=15&search=" + productSearchInput);
    const { data: clients } = useGetPageUnloadQuery("clients?per_page=6&search=" + clientName);
    const { data: products } = useGetPageUnloadQuery("products?per_page=6&is_sold=1&search=" + exchangeTitle);
    const { data: stores } = useGetPageQuery("stores?permission=order&per_page=200");

    useEffect(() => {
        if (orderStatuses && stores) {
            setOrderStatusId(orderStatuses[0].id);
            setStoreId(stores.data[0].id);
        }
    }, [orderStatuses, stores]);

    useEffect(() => {
        const outsideHandleClick = (e) => {
            if (
                searchClientRef.current &&
                !e.composedPath().includes(searchClientRef.current) &&
                inputClientRef.current &&
                !e.composedPath().includes(inputClientRef.current)
            ) {
                setShowSearchClientList(false);
            }
            if (
                inputImeitRef.current &&
                !e.composedPath().includes(inputImeitRef.current) &&
                searchProductRef.current &&
                !e.composedPath().includes(searchProductRef.current)
            ) {
                setShowSearchImeiList(false);
            }
            if (
                inputPositionRef.current &&
                !e.composedPath().includes(inputPositionRef.current) &&
                searchPositionRef.current &&
                !e.composedPath().includes(searchPositionRef.current)
            ) {
                setShowSearchPositionList(false);
            }
        };

        document.body.addEventListener("click", outsideHandleClick);

        return () => {
            document.body.removeEventListener("click", outsideHandleClick);
        };
    }, []);

    useEffect(() => {
        if (positions) {
            setTotalPrice(
                positions.reduce((calcPrice, product) => {
                    return calcPrice + product.price * product.quantity;
                }, 0) - exchangePrice
            );
            setTotalPriceWithDiscount(+totlaPrice - (discount / 100) * +totlaPrice);
        }
    }, [discount, positions, totlaPrice, exchangePrice]);

    const sendFormHandler = async () => {
        if (userPermission.user_permission_type_id !== 9 && clientName.length < 1 && clientPhone.length < 1) {
            return alert('Форми з подначкою "*" обов\'язкові до заповення');
        }
        const formData = {
            order_status_id: orderStatusId,
            store_id: storeId,
            is_prom: isProm,
            is_olx: isOLX,
            is_credit: isCredit,
            is_card: isCard,
            is_terminal: isTerminal,
            discount: discount,
            client_id: clientId,
            client_name: clientName,
            client_card: clientCard,
            client_phone: clientPhone,
            delivery_ttn: deliveryTtn,
            note: note,
            icloud_login: icloudLogin,
            icloud_password: icloudPassword,
            exchange_is_service: exchangeIsservice,
            exchange_title: exchangeTitle,
            exchange_imei_sn: exchangeImeiSn,
            exchange_status: exchangeStatus,
            exchange_price: exchangePrice,
            product_id: productId,
            credit_bank: creditBank,
            credit_contract: creditContract,
            credit_additional: creditAdditional,
            positions: positions,
            is_exchange: +isExchange,
        };

        try {
            await sendForm({
                body: formData,
                url: "orders",
                method: "POST",
            }).unwrap();
            // navigate("/orders");
        } catch (error) {
            alert(error.data.message);
        }
    };

    const onSelectClientHandler = (client) => {
        setClientId(client.id);
        setClientName(client.name);
        setClientPhone(client.phone);
        setClientCard(client.card);
        setShowSearchClientList(false);
    };

    const priceChangeHandler = (index, e) => {
        const newArr = [...positions];
        newArr[index].price = +e.target.value;
        setPositions(newArr);
    };

    const quantityChangeHandler = (index, e) => {
        const newArr = [...positions];
        newArr[index].quantity = +e.target.value;
        setPositions(newArr);
    };

    const deletePositionHandler = (index) => {
        const newArr = [...positions];
        setPositions(newArr.filter((position, i) => i !== index));
    };

    const onSelectProductHandler = (product) => {
        setExchangeImeiSn(product.imei_sn);
        setExchangeStatus(product.status);
        setExchangePrice(product.price);
        setExchangeTitle(product.title);
        setproductId(product.id);
        setShowSearchImeiList(false);
    };

    const addPositionHandler = (position) => {
        if ("imei_sn" in position) {
            setPositions([
                ...positions,
                {
                    id: position.id,
                    type: "products",
                    price: position.price,
                    quantity: 1,
                    title: position.title,
                    shipper: position?.shipper?.title_short,
                    imei: position.imei_sn,
                },
            ]);
        } else {
            setPositions([
                ...positions,
                {
                    id: position.id,
                    type: "services",
                    price: position.price,
                    title: position.title,
                    quantity: 1,
                },
            ]);
        }
        setShowSearchPositionList(false);
        setProductSearchInput("");
    };

    // useEffect(() => {
    //     if (postFormError && postFormError.status === 422 && postFormError?.data) {
    //         alert(postFormError?.data.message);
    //     }
    // }, [postFormError, isError]);

    // useEffect(() => {
    //     if (isSuccess) {
    //         succsesDataAddAlert();
    //         navigate("/order/" + sendFormData.id);
    //     }
    // }, [isSuccess]);

    return (
        <>
            {positions && orderStatuses && orderPositions && stores && (
                <div className="content">
                    <SaveBtn
                        isLoading={isLoading}
                        onBtnClick={sendFormHandler}
                    />
                    <div />
                    <div className="col-12">
                        <input
                            name="id"
                            type="hidden"
                        />
                        <input
                            name="store_id"
                            type="hidden"
                        />
                        <div className="d-flex justify-content-between align-items-center flex-wrap">
                            <div className="d-flex align-items-center flex-wrap">
                                <h1>Додати Замовлення</h1>
                                <div>
                                    <select
                                        className="form-select mx-2"
                                        name="status"
                                        value={orderStatusId}
                                        onChange={(e) => setOrderStatusId(e.target.value)}
                                    >
                                        {orderStatuses.map((orderStutus) => {
                                            return (
                                                <option
                                                    value={orderStutus.id}
                                                    key={orderStutus.id}
                                                >
                                                    {orderStutus.title}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                                <div>
                                    <button
                                        className="btn btn-warning mx-3 my-2"
                                        onClick={() => setIsExchange(+!isExchange)}
                                    >
                                        Додати обмін
                                    </button>
                                </div>
                            </div>
                            {/* <div className="float-right ml-sm-2">
                                <div className="float-end">
                                    <Link to={"/print_order"} state={[clientName, totlaPrice]}>
                                        <div>
                                            <img
                                                src={IconPrint}
                                                alt="React Logo"
                                                style={{ width: "41px", height: "41px", cursor: "pointer" }}
                                            />
                                        </div>
                                    </Link>
                                </div>
                            </div> */}
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12 col-sm-6 col-md-8">
                                <div className="card card-default">
                                    <div className="card-header d-flex justify-content-between flex-wrap">
                                        <div>Позиції замовлення</div>
                                        <div className="d-flex flex-wrap">
                                            <div className="custom-control custom-checkbox float-right mx-2">
                                                <input
                                                    className="form-check-input mx-2"
                                                    type="checkbox"
                                                    id="flexCheckDefault"
                                                    checked={isOLX}
                                                    onChange={(e) => setIsOLX(+e.target.checked)}
                                                />
                                                <label className="custom-control-label">Olx доставка</label>
                                            </div>
                                            <div className="custom-control custom-checkbox float-right mx-2">
                                                <input
                                                    className="form-check-input mx-2"
                                                    type="checkbox"
                                                    id="flexCheckDefault"
                                                    checked={isProm}
                                                    onChange={(e) => setIsProm(+e.target.checked)}
                                                />
                                                <label className="custom-control-label">Prom</label>
                                            </div>
                                            <div className="custom-control custom-checkbox float-right mx-2">
                                                <input
                                                    className="form-check-input mx-2"
                                                    type="checkbox"
                                                    id="flexCheckDefault"
                                                    checked={isTerminal}
                                                    onChange={(e) => setIsTerminal(+e.target.checked)}
                                                />
                                                <label className="custom-control-label">Оплата терміналом</label>
                                            </div>
                                            <div className="custom-control custom-checkbox float-right">
                                                <input
                                                    className="form-check-input mx-2"
                                                    type="checkbox"
                                                    id="flexCheckDefault"
                                                    checked={isCard}
                                                    onChange={(e) => setIsCard(+e.target.checked)}
                                                />
                                                <label className="custom-control-label">Оплата на карту</label>
                                            </div>
                                            <div className="custom-control custom-checkbox float-right mx-2">
                                                <input
                                                    className="form-check-input mx-2"
                                                    type="checkbox"
                                                    id="flexCheckDefault"
                                                    checked={isCredit}
                                                    onChange={(e) => setIsCredit(+e.target.checked)}
                                                />
                                                <label className="custom-control-label">Кредит</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="card-body"
                                        id="purchases"
                                    >
                                        <>
                                            <table className="table table-striped purchases_table">
                                                <tbody>
                                                    {positions.map((position, index) => {
                                                        return (
                                                            <tr
                                                                className="crow"
                                                                key={position.id}
                                                            >
                                                                <td className="middle_name">
                                                                    <Link
                                                                        className="related_product_name"
                                                                        to={"/product/" + position.id}
                                                                    >
                                                                        {position.title +
                                                                            ` ${
                                                                                position?.imei
                                                                                    ? `(${position?.imei?.slice(
                                                                                          position?.imei?.length - 5,
                                                                                          position?.imei?.length
                                                                                      )})`
                                                                                    : ""
                                                                            } `}
                                                                    </Link>
                                                                    <span className="badge bg-danger">
                                                                        {position?.shipper}
                                                                    </span>
                                                                </td>
                                                                <td className="middle_name text-right">
                                                                    <div className="row">
                                                                        <div className="col-xs-12 col-md-6">
                                                                            <div className="input-group">
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control"
                                                                                    name="purchases[price][397516]"
                                                                                    value={position.price}
                                                                                    onChange={(e) =>
                                                                                        priceChangeHandler(index, e)
                                                                                    }
                                                                                />
                                                                                <span className="input-group-text">
                                                                                    грн
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-xs-12 col-md-6">
                                                                            <div className="input-group">
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control"
                                                                                    value={position.quantity}
                                                                                    onChange={(e) =>
                                                                                        quantityChangeHandler(index, e)
                                                                                    }
                                                                                />

                                                                                <span className="input-group-text">
                                                                                    шт
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>

                                                                <td className="micro no-mobile"></td>
                                                                <td className="micro text-right">
                                                                    <div className="action_s delete">
                                                                        <i
                                                                            className="bi bi-trash fake-a"
                                                                            onClick={() => deletePositionHandler(index)}
                                                                        ></i>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                            {
                                                <div id="add_purchase">
                                                    <input
                                                        type="text"
                                                        name="related"
                                                        id="add_purchase"
                                                        className="input_autocomplete form-control"
                                                        placeholder="Виберіть товар або послугу"
                                                        autoComplete="off"
                                                        value={productSearchInput}
                                                        onChange={(e) => setProductSearchInput(e.target.value)}
                                                        ref={inputPositionRef}
                                                        onFocus={() => setShowSearchPositionList(true)}
                                                    />
                                                    <div ref={searchPositionRef}>
                                                        {showSearchPositionList && (
                                                            <AddPositionSelect
                                                                orderPositions={orderPositions}
                                                                addPositionHandler={addPositionHandler}
                                                                positions={positions}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            }
                                        </>
                                    </div>
                                </div>
                                <div className="card border-info mb-3">
                                    <div className="card-body">
                                        <h4>
                                            Всього: <b id="sub_total_price">{totlaPrice}</b> грн.
                                        </h4>
                                    </div>
                                </div>
                                <div className="card card-default">
                                    <div className="card-header">Знижка</div>
                                    <div className="card-body">
                                        <div className="input-group">
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="discount"
                                                value={discount}
                                                onChange={(e) => setDiscount(e.target.value)}
                                            />
                                            <span className="input-group-text">%</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="card border-info mb-3">
                                    <div className="card-body">
                                        <h4>
                                            Всього: <b id="total_price">{totlaPriceWithDiscount}</b> грн.
                                        </h4>
                                        {isTerminal ? (
                                            <h6
                                                class="text-danger"
                                                id="total_terminal"
                                            >
                                                Комісія терміналу:{" "}
                                                <b>{((totlaPriceWithDiscount / 100) * 3).toFixed(0)}</b> грн.
                                            </h6>
                                        ) : null}
                                    </div>
                                </div>
                                {permissions.includes("order_view") || permissions.includes("all") ? (
                                    <div className="saves_block">
                                        <button
                                            name="user_info"
                                            className="btn btn-primary"
                                            onClick={sendFormHandler}
                                        >
                                            {isLoading ? "Завантаження" : "Зберегти"}
                                        </button>
                                    </div>
                                ) : null}
                            </div>
                            <div
                                className="col-12 col-sm-6 col-md-4"
                                id="order_details"
                            >
                                <div className="card card-default card-exchange">
                                    <div className="card-header">Обрати магазин</div>
                                    <div className="card-body">
                                        <ul className="order_details">
                                            <li>
                                                <label className="form-label">Магазини</label>
                                                <select
                                                    className="form-select"
                                                    aria-label="Default select example"
                                                    value={storeId}
                                                    onChange={(e) => setStoreId(e.target.value)}
                                                >
                                                    {stores.data.map((store) => {
                                                        return (
                                                            <option
                                                                key={store.id}
                                                                value={store.id}
                                                            >
                                                                {store.title}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                {isExchange ? (
                                    <div className="card card-default card-exchange">
                                        <div className="card-header">Обмін на телефон </div>
                                        <div className="card-body">
                                            <ul className="order_details">
                                                <li>
                                                    <div className="d-flex justify-content-between">
                                                        <label className="float-start">Назва</label>
                                                        <div className="custom-control custom-checkbox float-end">
                                                            <label className="form-label">Передати в сервіс</label>
                                                            <input
                                                                className="form-check-input mx-2"
                                                                type="checkbox"
                                                                id="flexCheckDefault"
                                                                checked={exchangeIsservice}
                                                                onChange={(e) =>
                                                                    setExchangeIsService(+e.target.checked)
                                                                }
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="edit_order_detail mb-3">
                                                        <input
                                                            type="text"
                                                            name="exchange_product"
                                                            className="form-control"
                                                            id="model_name"
                                                            placeholder="Почніть вводити модель телефона"
                                                            autoComplete="off"
                                                            required="required"
                                                            ref={inputImeitRef}
                                                            onFocus={() => setShowSearchImeiList(true)}
                                                            value={exchangeTitle}
                                                            onChange={(e) => setExchangeTitle(e.target.value)}
                                                        />
                                                        <div ref={searchProductRef}>
                                                            {showSearchImeiList && (
                                                                <ProductsSearchList
                                                                    products={products.data}
                                                                    onSelectProductHandler={onSelectProductHandler}
                                                                />
                                                            )}
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <label className="form-label">IMEI/SN</label>
                                                    <div className="edit_order_detail mb-3">
                                                        <input
                                                            type="text"
                                                            name="exchange_imei"
                                                            className="form-control"
                                                            required="required"
                                                            value={exchangeImeiSn}
                                                            onChange={(e) => setExchangeImeiSn(e.target.value)}
                                                        />
                                                    </div>
                                                </li>
                                                <li>
                                                    <label className="form-label">Стан</label>
                                                    <div className="edit_order_detail mb-3">
                                                        <input
                                                            type="text"
                                                            name="exchange_status"
                                                            className="form-control"
                                                            required="required"
                                                            value={exchangeStatus}
                                                            onChange={(e) => setExchangeStatus(e.target.value)}
                                                        />
                                                    </div>
                                                </li>
                                                <li>
                                                    <label className="form-label">Оцінено на суму</label>
                                                    <div className="edit_order_detail mb-3">
                                                        <input
                                                            type="text"
                                                            name="exchange_price"
                                                            className="form-control"
                                                            required="required"
                                                            value={exchangePrice}
                                                            onChange={(e) => setExchangePrice(e.target.value)}
                                                        />
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                ) : null}
                                <div className="card card-default">
                                    <div className="card-header d-flex justify-content-between">Клієнт</div>
                                    <div className="card-body">
                                        <ul className="order_details">
                                            <li>
                                                <label className="form-label">Клієнт*</label>
                                                <div className="edit_order_detail mb-3">
                                                    <input
                                                        type="hidden"
                                                        name="user_id"
                                                    />
                                                    <input
                                                        ref={inputClientRef}
                                                        name="name"
                                                        className="form-control"
                                                        id="client_name"
                                                        type="text"
                                                        placeholder="Проскануйте карту або почніть вводити Імя"
                                                        autoComplete="off"
                                                        value={clientName}
                                                        onChange={(e) => setClientName(e.target.value)}
                                                        onFocus={() => setShowSearchClientList(true)}
                                                    />
                                                    <div ref={searchClientRef}>
                                                        {showSearchClientList && (
                                                            <SearchList
                                                                clients={clients.data}
                                                                onSelectClientHandler={onSelectClientHandler}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <label className="form-label">Карта клієнта</label>
                                                <div className="edit_order_detail mb-3">
                                                    <input
                                                        name="card"
                                                        className="form-control"
                                                        id="client_card"
                                                        type="text"
                                                        value={clientCard}
                                                        onChange={(e) => setClientCard(e.target.value)}
                                                    />
                                                </div>
                                            </li>
                                            <li>
                                                <label className="form-label">Телефон*</label>
                                                <div className="edit_order_detail mb-3">
                                                    <input
                                                        name="phone"
                                                        className="form-control"
                                                        type="text"
                                                        value={clientPhone}
                                                        onChange={(e) => setClientPhone(e.target.value)}
                                                    />
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                {isCredit ? (
                                    <div
                                        id="credit_info"
                                        className="card card-default"
                                    >
                                        <div className="card-header">Інформація про кредит</div>
                                        <div className="card-body">
                                            <ul className="order_details">
                                                <li>
                                                    <label className="form-label">Банк</label>
                                                    <select
                                                        className="form-select mb-3"
                                                        aria-label="Default select example"
                                                        onChange={(e) => setCreditBank(e.target.value)}
                                                        value={creditBank}
                                                    >
                                                        <option value="alfabank">Альфа-Банк</option>
                                                        <option value="ukrsibbank">УкрСиббанк</option>
                                                    </select>
                                                </li>
                                                <li>
                                                    <label className="form-label">Номер договору</label>
                                                    <div className="edit_order_detail mb-3">
                                                        <input
                                                            name="credit_number"
                                                            className="form-control"
                                                            value={creditContract}
                                                            onChange={(e) => setCreditContract(e.target.value)}
                                                        />
                                                    </div>
                                                </li>
                                                <li>
                                                    <label className="form-label">Додатково</label>
                                                    <div className="edit_order_detail mb-3">
                                                        <input
                                                            name="credit_additional"
                                                            className="form-control"
                                                            value={creditAdditional}
                                                            onChange={(e) => setCreditAdditional(e.target.value)}
                                                        />
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                ) : null}
                                <div className="card card-default">
                                    <div className="card-header">Доставка (ТТН)</div>
                                    <div className="card-body">
                                        <ul className="order_details mb-0">
                                            <li>
                                                <div className="edit_note">
                                                    <input
                                                        name="ttn"
                                                        className="form-control"
                                                        value={deliveryTtn}
                                                        onChange={(e) => setDeliveryTtn(e.target.value)}
                                                    />
                                                    <span
                                                        className="w_time"
                                                        style={{ color: "#000" }}
                                                    ></span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="card card-default">
                                    <div className="card-header">Примітка менеджера</div>
                                    <div className="card-body">
                                        <ul className="order_details">
                                            <li>
                                                <div className="edit_note">
                                                    <textarea
                                                        name="note"
                                                        className="form-control"
                                                        minLength="3"
                                                        value={note}
                                                        onChange={(e) => setNote(e.target.value)}
                                                    ></textarea>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="card card-default">
                                    <div className="card-header">iCloud</div>
                                    <div className="card-body">
                                        <ul className="order_details">
                                            <li>
                                                <label className="form-label">iCloud логін</label>
                                                <div className="edit_order_detail mb-3">
                                                    <input
                                                        name="icloud_login"
                                                        className="form-control"
                                                        value={icloudLogin}
                                                        onChange={(e) => setIcloudLogin(e.target.value)}
                                                    />
                                                </div>
                                            </li>
                                            <li>
                                                <label className="form-label">iCloud пароль</label>
                                                <div className="edit_order_detail mb-3">
                                                    <input
                                                        name="icloud_pass"
                                                        className="form-control"
                                                        value={icloudPassword}
                                                        onChange={(e) => setIcloudPassword(e.target.value)}
                                                    />
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Order;
